import React from "react";
import { tokens } from "../theme";
import { Button, Avatar } from "@mui/material";
import styled from "@emotion/styled";

const FilterBtn = styled(Button)({
  border: "1px solid  #2A1D2233",
  backgroundColor: tokens.card,
  color: "#2A1D22",
  fontSize: "1rem",
  lineHeight: 1.7,
  fontWeight: 500,
  letterSpacing: "0.19px",
  wordWrap: "break-word",
  textAlign: "center",
  textTransform: "none",
});

const FilterButton = (props) => {
  const { onClick, disabled, startIcon, endIcon, children, sx } = props;

  const handleOnClick = (e) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <FilterBtn 
     onClick={handleOnClick}
     disabled={disabled}
     sx={{
       ...sx,
       "&:hover": {
         background: tokens.card,
         color: "#8C3B5E",
         border: "1px solid #8C3B5E",
       },
     }}
     startIcon={startIcon?<Avatar src={startIcon} style={{ width: '1.125rem', height: '1.125rem' }}/>:null}
     endIcon={endIcon?<Avatar src={endIcon} style={{ width: '1.125rem', height: '1.125rem' }}/>:null}
    >
      {children || "click me..."}
    </FilterBtn>
  );
};

export default FilterButton;
